import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { clearAuth, getToken, getUser } from '@/utils/auth'
import { USER_ROLES } from '@/constants/roles'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: {
      title: '登录',
      guestOnly: true
    }
  },
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue'),
    meta: {
      title: '工作台',
      requiresAuth: true
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/ProfileView.vue'),
    meta: {
      title: '个人中心',
      requiresAuth: true
    }
  },
  {
    path: '/module/:slug',
    name: 'module-detail',
    component: () => import('@/views/ModulePlaceholderView.vue'),
    meta: {
      title: '业务模块',
      requiresAuth: true
    }
  },
  {
    path: '/admin',
    component: () => import('@/views/admin/AdminLayout.vue'),
    redirect: { name: 'admin-modules' },
    meta: {
      title: '权限管理',
      requiresAuth: true,
      roles: [USER_ROLES.SUPER_ADMIN]
    },
    children: [
      {
        path: 'modules',
        name: 'admin-modules',
        component: () => import('@/views/admin/ModuleManagementView.vue'),
        meta: { title: '模块管理' }
      },
      {
        path: 'menus',
        redirect: { name: 'admin-modules' }
      },
      {
        path: 'accounts',
        name: 'admin-accounts',
        component: () => import('@/views/admin/AccountManagementView.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: 'notices',
        name: 'admin-notices',
        component: () => import('@/views/admin/NoticeManagementView.vue'),
        meta: { title: '公告管理' }
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior: () => ({ top: 0 })
})

router.beforeEach((to) => {
  const token = getToken()
  const user = getUser()

  document.title = `${to.meta.title || '页面'} - 心河综合管理平台`

  if (token && !user) {
    clearAuth()
    return { name: 'login' }
  }

  if (to.meta.requiresAuth && !token) {
    return {
      name: 'login',
      query: to.fullPath === '/' ? {} : { redirect: to.fullPath }
    }
  }

  if (to.meta.guestOnly && token) {
    return { name: 'home' }
  }

  if (to.meta.roles?.length && (!user?.role || !to.meta.roles.includes(user.role))) {
    return { name: 'home' }
  }

  return true
})

export default router
